var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.alerts),function(a){return _c('alert',{key:a.id,attrs:{"type":a.type}},[_c('span',{domProps:{"innerHTML":_vm._s(a.message)}})])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }